import React, { useEffect, useState } from 'react';
import Loading from 'common/components/Loading';
import { simpleFetch, makeApiRequestAndHandleError } from 'common/utils/http';
import AdminPane from './components/AdminPane';
import AttributeTypePane from './components/AttributeTypePane';
import TypeInfoPane from './components/TypeInfoPane';
import AddOrEditAttributeTypePane from './components/AddAttributeTypePane';
import ReloadAllAttributesContext from './context';

const AdminAttributesPage = () => {
  const [genres, setGenres] = useState([]);
  const [currGenre, setCurrGenre] = useState(undefined);

  const [sections, setSections] = useState([]);
  const [currSection, setCurrSection] = useState(undefined);

  const [attrTypes, setAttrTypes] = useState([]);
  const [dispAttrType, setDispAttrType] = useState(undefined);
  const [editAttrType, setEditAttrType] = useState(undefined);

  const [showAddAttrType, setShowAddAttrType] = useState(false);

  const loadGenres = () => {
    setGenres([]);
    setSections([]);
    setAttrTypes([]);
    setCurrGenre(null);
    setCurrSection(null);
    setDispAttrType(null);
    setEditAttrType(null);
    setShowAddAttrType(false);

    makeApiRequestAndHandleError(async () => {
      simpleFetch('/api/v1/attributes?include-entire-structure=true').then(data =>
        setGenres(data.genres)
      );
    });
  };

  useEffect(loadGenres, []);

  const onSelectGenre = genre => {
    setCurrGenre(genre);
    setCurrSection(null);
    setDispAttrType(null);
    setEditAttrType(null);
    setShowAddAttrType(false);

    setSections(genre.sections);
    setAttrTypes([]);
  };
  const onSelectSection = section => {
    setCurrSection(section);
    setDispAttrType(null);
    setEditAttrType(null);
    setShowAddAttrType(false);

    setAttrTypes(section.attribute_types);
  };
  const onSelectAttrType = attrType => {
    setDispAttrType(attrType);
    setEditAttrType(null);
    setShowAddAttrType(false);
  };

  if (!genres || genres.length === 0) {
    return <Loading />;
  }
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <ReloadAllAttributesContext.Provider value={{ reload: loadGenres }}>
      <div style={{ display: 'flex' }}>
        <AdminPane
          onSelectItem={onSelectGenre}
          paneItems={genres}
          paneName="Genre"
          selectedItem={currGenre}
        />
        <AdminPane
          onSelectItem={onSelectSection}
          paneItems={sections}
          paneName="Section"
          parentItem={currGenre}
          selectedItem={currSection}
        />
        <AttributeTypePane
          onAdd={currSection ? setShowAddAttrType : null}
          onEdit={e => {
            e.stopPropagation();

            setEditAttrType(dispAttrType);
            setShowAddAttrType(true);
          }}
          onSelectItem={onSelectAttrType}
          paneItems={attrTypes}
          paneName="Attribute Type"
          selectedItem={dispAttrType}
        />
        {currSection && showAddAttrType ? (
          <AddOrEditAttributeTypePane
            editAttrType={editAttrType}
            onCancel={() => setShowAddAttrType(false)}
            onSubmit={loadGenres}
            section={currSection}
          />
        ) : (
          <TypeInfoPane attrType={dispAttrType} paneName="Type Info" />
        )}
      </div>
    </ReloadAllAttributesContext.Provider>
  );
};

export default AdminAttributesPage;
